import styled from 'styled-components';

export const CenterDiv = styled.div`
  text-align: center;
`;
